export default {
  loading: 'Prijzen laden…',
  default_modal: {
    title: 'Standaardprijslijst',
    description:
      'De standaardprijzen die elke partner zonder eigen overschrijving erft. Wijzigingen hebben nooit invloed op lopende licenties.',
    saved: 'Standaardprijslijst opgeslagen.',
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  toasts: {
    load_error: 'Prijsgegevens konden niet worden geladen.',
    save_error: 'Opslaan mislukt — probeer het opnieuw.',
    prices_saved: 'Prijslijst opgeslagen.',
    license_created: 'Licentie aangemaakt.',
    lifecycle: {
      pause: 'Licentie gepauzeerd.',
      resume: 'Licentie hervat.',
      cancel: 'Licentie geannuleerd.',
    },
  },
  price_book: {
    title: 'Prijslijst',
    read_only_notice:
      'Partnerprijzen overschrijven de standaardlijst. Lopende licenties behouden hun vastgestelde prijzen.',
    editing_notice: 'Bewerken — nieuwe prijzen gelden alleen voor licenties die vanaf nu worden aangemaakt.',
    columns: {
      service: 'Dienst',
      cost_price: 'Brutoprijs ({{currency}}/maand, incl. btw)',
    },
    add_ons: 'Add-ons',
    missing_price: '{{name}} is ingeschakeld maar heeft geen prijs — stel er een in of schakel het uit.',
    incomplete_tier:
      '{{name}} heeft zowel een volumeprijs als het aantal actieve locaties vanaf waar dit geldt nodig, of geen van beide.',
    invalid_tier:
      'De volumeprijs van {{name}} moet lager zijn dan de standaardprijs, vanaf minimaal 2 actieve locaties.',
    tier: {
      from: 'Volumeprijs vanaf',
      live_locations: 'actieve locaties',
      counted_one: 'Deze partner heeft {{count}} actieve gelicentieerde locatie die meetelt voor de volumeprijs.',
      counted_other: 'Deze partner telt {{count}} actieve licentielocaties mee voor de volumeprijs.',
    },
    snapshot_note:
      'Prijzen worden vastgelegd op een licentie bij aanmaak — de lijst bewerken wijzigt nooit lopende licenties.',
    types: {
      base: 'Basis',
      add_on: 'Add-on',
    },
  },
  volume_discount: {
    title: 'Volumekorting',
    read_only_notice:
      'Zodra een maandelijkse factuur het drempelaantal licenties bereikt, wordt de korting toegepast op alle licentiekosten van die cyclus.',
    editing_notice: 'Bewerken — de nieuwe instellingen gelden vanaf de volgende factuurperiode.',
    threshold_label: 'Licentiedrempel',
    percent_label: 'Korting',
    invalid: 'Voer een drempel van minimaal 1 in en een korting tussen 0 en 100%.',
    saved: 'Volumekorting opgeslagen.',
    note: 'Telt licenties die in de cyclus zelf worden gefactureerd; overgedragen maanden zijn uitgesloten. 0% (de standaardwaarde) schakelt de korting uit — anders zou die bovenop de volumeprijs in de prijslijst komen.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Een testrestaurant wordt nooit gefactureerd en kan daarom geen licentie hebben.',
    title: 'Restaurantlicenties',
    select_company: 'Selecteer een restaurant',
    add_license: 'Licentie toevoegen',
    no_companies: 'Deze partner heeft nog geen restaurants.',
    no_licenses: 'Nog geen licenties voor dit restaurant.',
    activated_at: 'Actief sinds',
    next_period_preview: 'Volgende maand (pro rata, vóór volumekorting)',
    statuses: {
      active: 'Actief',
      paused: 'Gepauzeerd',
      canceled: 'Geannuleerd',
    },
    columns: {
      product: 'Dienst',
      locked_price: 'Vastgestelde prijs / maand',
      quantity: 'Aantal',
      trial_ends: 'Gratis tot',
    },
    price_tiers: {
      volume: 'Volumetarief',
      locked: 'Verouderde prijs',
    },
  },
  lifecycle: {
    pause: {
      action: 'Pauzeren',
      title: 'Deze licentie pauzeren?',
      description:
        'Gepauzeerde dagen worden niet gefactureerd. De licentie behoudt de vastgestelde prijzen en kan op elk moment worden hervat.',
      confirm: 'Pauzeren',
    },
    resume: {
      action: 'Hervatten',
      title: 'Deze licentie hervatten?',
      description: 'Facturering gaat vandaag verder tegen de vastgestelde prijzen.',
      confirm: 'Hervatten',
    },
    cancel: {
      action: 'Licentie annuleren',
      title: 'Deze licentie annuleren?',
      description:
        'De huidige maand wordt pro rata gefactureerd tot en met vandaag. Dit kan niet ongedaan worden gemaakt — een nieuwe licentie wordt aangemaakt tegen huidige lijstprijzen.',
      confirm: 'Licentie annuleren',
    },
  },
  add_license: {
    title: 'Een licentie toevoegen',
    description: 'Selecteer de diensten voor dit restaurant. Prijzen worden vastgelegd op de licentie bij aanmaak.',
    per_month: ' / maand',
    create: 'Licentie aanmaken',
    no_priced_products:
      'Nog geen producten hebben een bruikbare prijs voor deze partner — stel eerst de prijslijst in.',
  },
};
